module.exports = __webpack_public_path__ + "static/media/06_360.4bdef7bf.jpeg";